import React from 'react';

/**
 * ContactSidebar - Seitenleiste zur Anzeige von Kontaktinformationen.
 *
 * @param {Object} props - Props der Komponente.
 * @param {Object} props.contact - Der anzuzeigende Kontakt.
 * @param {Array} props.companies - Liste der Unternehmen (für die Anzeige des Unternehmensnamens).
 * @param {Function} props.onClose - Funktion zum Schließen der Seitenleiste.
 * @returns {JSX.Element} - Die gerenderte Seitenleiste.
 */
const ContactSidebar = ({ contact, companies, onClose }) => {
  if (!contact) return null;

  // Unternehmen des Kontakts finden
  const company = companies.find((c) => c.id === contact.companyId);

  return (
    <div className="sidebar left-sidebar">
      <div className="sidebar-header">
        <h3>Kontaktinformationen</h3>
        <button className="close-sidebar" onClick={onClose}>
          ×
        </button>
      </div>
      <div className="sidebar-content">
        <p>
          <strong>Name:</strong> {contact.firstName} {contact.lastName}
        </p>
        <p>
          <strong>Unternehmen:</strong> {company?.name || 'Unbekannt'}
        </p>
        <p>
          <strong>Position:</strong> {contact.position || 'Nicht angegeben'}
        </p>
        <p>
          <strong>E-Mail:</strong> {contact.email || 'Nicht angegeben'}
        </p>
        <p>
          <strong>Telefon:</strong> {contact.phone || 'Nicht angegeben'}
        </p>
        <p>
          <strong>Bemerkungen:</strong> {contact.remarks || 'Keine'}
        </p>
        <p>
          <strong>Standardkontakt:</strong> {contact.isDefault ? 'Ja' : 'Nein'}
        </p>
        <p>
          <strong>Status:</strong> {contact.active ? 'Aktiv' : 'Inaktiv'}
        </p>
      </div>
    </div>
  );
};

export default ContactSidebar;